import { render } from "./virtualdetails.vue?vue&type=template&id=48ebd48a&scoped=true&ts=true"
import script from "./virtualdetails.vue?vue&type=script&lang=ts"
export * from "./virtualdetails.vue?vue&type=script&lang=ts"

import "./virtualdetails.vue?vue&type=style&index=0&id=48ebd48a&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ebd48a"]])

export default __exports__